// extracted by mini-css-extract-plugin
export default {"ctaContent":"CTAContent_ctaContent__lJN1i","title":"CTAContent_title__hK6j3","subtitle":"CTAContent_subtitle__et7wQ","buttonGroup":"CTAContent_buttonGroup__5yrUo"};